<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2">
            <bita-bootbutton
              type="primary"
              title="افزودن خبر"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="createArticle"
            />
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :server-paging="true"
            :hasRow="false"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :batch="true"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="form"
      :props-categories="categories"
      :props-users="users"
      modal-id="edit-modal"
      title="ویرایش خبر"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :props-data="form"
      :props-categories="categories"
      :props-users="users"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن خبر"
      @on-submit="handleCreate"
    />
    <views-modal
      :users="articleUsers"
      modal-id="views-modal"
      title="مشاهده کرده ها"
    />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: article}">
      <g-list>
        <g-list-item
          title="ویرایش خبر"
          icon="fas fa-pen-square"
          @click="edit(article)"
        />
        <g-list-item
          title="مشاهده لیست"
          icon="fas fa-list"
          @click="showUsers(article)"
        />
        <g-list-item
          title="حذف خبر"
          icon="fa fa-times"
          @click="deleteArticle(article)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>

<script>
import Form from "./Form";
import Views from "./Views";
import GContextMenu from "../../components/GContextMenu.vue";
import GList from "../../components/listItem/GList.vue";
import GListItem from "../../components/listItem/GListItem.vue";

export default {
  components: {
    "form-modal": Form,
    "views-modal": Views,
    GContextMenu,
    GList,
    GListItem,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت اخبار",
          link: "/articles",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      form: {
        id: 0,
        title: "",
        category_id: "",
        introduction: "",
        content: "",
        publish_at: "",
        expire_at: "",
        is_special: 0,
        thumbnail: "",
        is_private: 0,
        priority:0,
        users: [],
      },
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "title", title: "عنوان", width: "80px" },
        { field: "category_name", title: "دسته بندی", width: "80px" },
        {
          field: "publish_at",
          title: "تاریخ انتشار",
          template: (e) =>
            e.publish_at ? this.$getJalaliDateTime(e.publish_at) : "-",
          width: "80px",
        },
        {
          field: "priority",
          title: "اولویت نمایش",
          width: "80px",
        },
          {
          field: "is_private",
          title: "خصوصی",
          template: (e) => (e.is_private ? "بله" : "خیر"),
          width: "80px",
        },
        {
          field: "is_special",
          title: "ویژه",
          template: (e) => (e.is_special ? "بله" : "خیر"),
          width: "80px",
        },
        {
          field: "is_private",
          title: "خصوصی",
          template: (e) => (e.is_private ? "بله" : "خیر"),
          width: "80px",
        },
        {
          title: "عملیات",
          command: [],
          width: 50,
        },
      ],
      categories: {},
      users: {},
      articleUsers: [],
    };
  },
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  methods: {
    gridCommands() {
      return [
        {
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        },
      ];
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      this.$persistClient("get", "/management/articles")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();

      this.$persistClient("get", "categories").then((res) => {
        this.categories = res.data;
      });

      this.$persistClient("get", "drivers").then((res) => {
        this.users = res.data;
      });
    },
    edit(article) {
      this.form = article;
      this.statusChangeModalEdit();
    },
    deleteArticle(articles) {
      this.$alert(
        "question",
        `آیا از حذف ${articles.title} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `management/articles/${articles.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createArticle() {
      this.form = {};
      this.statusChangeModalCreate();
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        ...e,
        _method: "patch",
      };
      this.$persistClient(
        "post",
        `management/articles/${e.id}`,
        this.$getFormData(data)
      )
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
        });
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        ...e,
      };
      this.$persistClient(
        "post",
        "management/articles",
        this.$getFormData(data)
      )
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
          this.statusChangeModalCreate();
        })
        .finally((res) => {
          this.isLoadingModal = false;
        });
    },
    showUsers(article) {
      this.articleUsers = article.users;
      $("#views-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
  },
};
</script>
